export default function auth(dispatch) {
  return error => {

    if(error.response && error.response.status == 401) {
      dispatch({ type: 'page.preload', location: '/login' })
    }

    throw error;
  }
}



// WEBPACK FOOTER //
// ../~/shared/src/utils/redux/auth.js